module.exports = __webpack_public_path__ + "static/media/logo.4562fbf9.svg";